import { useEffect, useRef, useState } from 'react';
import { Grid } from '@mui/material';
import type { CustomerSearchParams } from '@shared/api';
import { Input, useDebounce } from '@shared';

interface Props {
  onSubmit(search: CustomerSearchParams): void;
}

export const CustomersSearchForm = (props: Props) => {
  const [filterCriteria, setFilterCriteria] = useState<CustomerSearchParams>({});
  const isInitialMount = useRef(true);

  const debouncedFilterCriteria = useDebounce(filterCriteria);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      props.onSubmit({ ...debouncedFilterCriteria });
    }
  }, [debouncedFilterCriteria]);

  return (
    <form>
      <Grid container>
        <Grid item xs={12}>
          <Input
            name='accountNumber'
            label='Account Number'
            value={filterCriteria.accountNumber || ''}
            onChange={(e) => setFilterCriteria((prev) => ({ ...prev, accountNumber: e.target.value }))}
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            name='cardNumber'
            label='Card Number'
            value={filterCriteria.cardNumber || ''}
            onChange={(e) => setFilterCriteria((prev) => ({ ...prev, cardNumber: e.target.value }))}
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            name='fullName'
            label='Full Name'
            value={filterCriteria.fullName || ''}
            onChange={(e) => setFilterCriteria((prev) => ({ ...prev, fullName: e.target.value }))}
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            name='passport'
            label='Passport / ID Card Number'
            value={filterCriteria.passportIdCard || ''}
            onChange={(e) => setFilterCriteria((prev) => ({ ...prev, passportIdCard: e.target.value }))}
          />
        </Grid>
      </Grid>
    </form>
  );
};
